import { useEffect, useCallback } from 'react';
import './toastNotification.css';

export default function ToastNotification({ message, type, onClose }) {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (message) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [message, handleKeyDown]);

  if (!message) return null;

  return (
    <div
      className={`toast-notification ${type}`}
      onClick={onClose}
      onKeyDown={(e) => e.key === 'Enter' && onClose()}
      role="alert"
      aria-live="assertive"
      tabIndex={0}
      aria-label={`${type === 'success' ? 'Success' : 'Error'}: ${message}. Press Escape to dismiss.`}
    >
      <p>{message}</p>
    </div>
  );
}
